import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { MatInput } from '@angular/material/input';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { User } from '@data/models/user.model';
import { buildPageSizeOptions } from '@shared/utils/utilities';

const DEFAULT_LIST_SIZE = 10;

@Component({

    selector: 'syn-users-table',
    templateUrl: 'users-table.component.html',
    styleUrls: ['users-table.component.scss']
})
export class UsersTableComponent implements OnInit, AfterViewInit, OnChanges {

    @Input() users: User[];
    @Input() displayedColumns = ['id', 'fullName', 'job-title', 'is247', 'email', 'phone'];
    @Input() message: string;
    @Input() pageSize: Number;
    @Input() pageSizeOptions: Number[] = [];
    @Input() displayLoadMore = false;

    // eslint-disable-next-line @angular-eslint/no-output-rename
    @Output() loadUsers: EventEmitter<any> = new EventEmitter();
    // eslint-disable-next-line @angular-eslint/no-output-rename
    @Output() filterUsers: EventEmitter<any> = new EventEmitter();

    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    dataSource: MatTableDataSource<User>;
    showPaginator = false;

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    ngOnInit() {
        this.pageSizeOptions = buildPageSizeOptions(this.users);
        this.pageSize = this.pageSizeOptions.length === 0 ? 0 : DEFAULT_LIST_SIZE;
        this.dataSource = new MatTableDataSource<User>(this.users || []);
        this.showPaginator = (this.users.length > DEFAULT_LIST_SIZE);
        if (this.displayLoadMore) {
            this.showPaginator = false;
        }
    }

    ngOnChanges() {
        if (this.users && this.dataSource) {
            this.dataSource.data = this.users;
        }
    }

    applyFilter(filterValue: string, input?: MatInput) {
        if (input) {
            input.value = filterValue;
        }
        this.filterUsers.emit(filterValue);
    }

    public async loadMore(): Promise<void> {
        this.loadUsers.emit();
    }
}
